<template>
    <div>
        <dynamic-toolbar
            :loading="loading.orderHistory"
            icon="mdi-cart"
            title="Order requisition"
            color="indigo"
            theme="dark"
        >
            <template #buttons>
                <v-btn
                    color="#24A39D"
                    depressed
                    class="ml-2"
                    large
                    dark
                    @click="openOrderDialog('new')"
                >
                    <v-icon left>mdi-plus</v-icon>
                    New Order
                </v-btn>
            </template>
        </dynamic-toolbar>
        <v-card outlined>
            <v-card-title>
                <h3 style="margin-right: 20px;font-weight: 400">Order History</h3>
                <v-row>
                    <!-- <v-col cols="12" md="2">
                        <v-text-field
                            v-model="startDate"
                            label="Start Date"
                            hide-details
                            prepend-icon="mdi-calendar"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-text-field
                            v-model="endDate"
                            label="End Date"
                            hide-details
                            prepend-icon="mdi-calendar"
                            placeholder="YYYY-MM-DD"
                            v-mask="'####-##-##'"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="2">
                        <v-btn
                            color="indigo"
                            outlined
                            @click="getOrderHistory"
                            style="margin-top: 20px;"
                            small
                        >
                            <v-icon left>
                                mdi-shopping-search
                            </v-icon>
                            Get Order History
                        </v-btn>
                    </v-col> -->

                    <!-- <v-col cols="12" md="2">
                        <v-btn
                            color="success"
                            depressed
                            small
                            @click="downloadOrderHistoryReport"
                            outlined
                            style="margin-top: 20px;"
                        >
                            <v-icon left>mdi-file-excel</v-icon>
                            Download Report
                        </v-btn>
                    </v-col> -->

                    <v-spacer></v-spacer>

                    <v-col cols="12" md="8">
                        <v-text-field
                            v-model="searchOrderHistory"
                            append-icon="mdi-magnify"
                            label="Search here"
                            hide-details
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="1">
                        <v-icon
                            @click="getOrderHistory()"
                            class="ml-3 mt-5"
                            color="indigo"
                        >
                            mdi-refresh
                        </v-icon>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row justify="center">
                    <v-col cols="12">
                        <v-data-table
                            :headers="orderHistoryHeaders"
                            :items="orderHistoryItems"
                            :search="searchOrderHistory"
                            :loading="loading.orderHistory"
                            :items-per-page="15"
                            item-key="OrderID"
                            show-expand
                            single-expand
                            :expanded.sync="expanded"
                            dense
                        >
                            <template v-slot:expanded-item="{ headers, item }">
                                <td :colspan="headers.length" style="background-color: #fff;padding: 0;">
                                    <v-card outlined style="border: 1px #9f9dd0 solid;">
                                        <v-card-title class="title" style="margin-bottom: 10px;font-weight: 400;">
                                            Order Details
                                        </v-card-title>
                                        <v-card-text>
                                            <v-row>
                                                <v-col cols="12" md="12">
                                                    <v-text-field
                                                        v-model="item.special_instructions"
                                                        label="Special Instructions"
                                                        readonly
                                                        hide-details
                                                        outlined
                                                        dense
                                                    ></v-text-field>
                                                </v-col>
                                                <v-col cols="8" md="8">
                                                    <v-row>
                                                        <v-col cols="6" md="6">
                                                            <v-text-field
                                                                v-model="item.order_runout_date"
                                                                label="Runout Date"
                                                                readonly
                                                                hide-details
                                                                outlined
                                                                dense
                                                                class="mb-6"
                                                            ></v-text-field>
                                                            <v-text-field
                                                                v-model="item.order_runout_time"
                                                                label="Runout Time"
                                                                readonly
                                                                hide-details
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                        <v-col cols="6" md="6">
                                                            <v-text-field
                                                                v-model="item.order_retain_time"
                                                                label="Retain Time"
                                                                readonly
                                                                hide-details
                                                                outlined
                                                                dense
                                                            ></v-text-field>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                                <v-col cols="4" md="4">
                                                    <v-row>
                                                        <v-col cols="12" md="12">
                                                            <v-simple-table dense>
                                                                <template v-slot:default>
                                                                <thead>
                                                                    <tr>
                                                                        <th class="text-left" style="background-color: #787879;color: #fff;">
                                                                            Product
                                                                        </th>
                                                                        <th class="text-left" style="background-color: #787879;color: #fff;">
                                                                            Product Code
                                                                        </th>
                                                                        <th class="text-left" style="background-color: #787879;color: #fff;">
                                                                            Product Quantity
                                                                        </th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr
                                                                        v-for="det in item.order_details"
                                                                        :key="det.OrderProdID"
                                                                    >
                                                                        <td>{{ det.product_name }}</td>
                                                                        <td>{{ det.product_code }}</td>
                                                                        <td>
                                                                            {{ formatNumber(det.product_quantity, 0) }}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                                </template>
                                                            </v-simple-table>
                                                        </v-col>
                                                    </v-row>
                                                </v-col>
                                            </v-row>            
                                        </v-card-text>
                                    </v-card>
                                </td>
                            </template>

                            <template v-slot:item.order_requested_date="{ item }">
                                <p style="margin: 0;padding: 0;">{{ formatDatetime(item.order_requested_date) }}</p>
                            </template>

                            <template v-slot:item.order_status="{ item }">
                                <v-chip
                                    :color="
                                        item.order_status == 'PENDING' ? 'warning' :
                                        item.order_status == 'REJECTED' ? 'error' :
                                        item.order_status == 'ACTIVE' ? 'success' :
                                        item.order_status == 'DONE' || item.order_status == 'FORCEDCOMPLETION' ? '#7d3c98' : 'warning'
                                    "
                                    text-color="white"
                                    small
                                    class="pa-2"
                                    style="font-weight: 500;"
                                >
                                    {{ item.order_status !== 'FORCEDCOMPLETION' ? item.order_status : 'DONE' }}
                                </v-chip>
                            </template>

                            <template v-slot:item.edit="{ item }">
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(item)"
                                >
                                    mdi-pencil
                                </v-icon>
                            </template>
                        </v-data-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <order-requisition-dialog
            :dialogStatus="orderRequisitionDialogStatus"
            :dialogType="dialogType"
            :orderHistoryItem="orderHistoryItem"
            :currentUserApp="currentUserApp"
            :collections="collections"
            :loading="loading"
            @close:dialog="orderRequisitionDialogStatus = false"
            @update:history="getOrderHistory()"
        ></order-requisition-dialog>
    </div>
</template>

<script>
import DynamicToolbar from '../../../components/Global/Utils/DynamicToolbar.vue';
import OrderRequisitionDialog from '../../../components/ExternalUsers/Customers/OrderRequisitionDialog.vue';
import axios from 'axios';

export default {
    name: 'CustomerOrderRequisition',
    props: [],
    components: {
        DynamicToolbar,
        OrderRequisitionDialog
    },
    data: function () {
        return {
            searchOrderHistory: '',
            orderHistoryHeaders: [
                { text: '', value: 'data-table-expand', class: 'custom-header' },
                { text: 'OrderID', value: 'OrderID', class: 'custom-header' },
                { text: 'OrderStatus', value: 'order_status', class: 'custom-header' },
                { text: 'Terminal', value: 'terminal_name', class: 'custom-header' },
                { text: 'Supplier', value: 'supplier_name', class: 'custom-header' },
                { text: 'Station', value: 'station_name', class: 'custom-header' },
                { text: 'Requested Date', value: 'order_requested_date', class: 'custom-header' },
                { text: 'Edit', value: 'edit', class: 'custom-header' },
            ],
            orderDetailsHeaders: [
                { text: 'Product', value: 'product_name' },
                { text: 'Product Code', value: 'product_code' },
                { text: 'Product Quantity', value: 'product_quantity' },
            ],
            orderHistoryItems: [],
            loading: {
                orderHistory: true,
                collections: true,
            },
            expanded: [],
            orderRequisitionDialogStatus: false,
            dialogType: 'new',
            currentUserApp: {},
            orderHistoryItem: {},
            collections: {},
        }
    },
    async mounted() {
        // await this.getCurrentUser();
        this.getCollections();
        this.getOrderHistory();

        const query = this.$route.query;
        const order = query.order || '';
        if (order) {
            this.searchOrderHistory = order;
        }
    },
    methods: {
        getCollections() {
            console.log('Get collections');
            // console.log(this.currentUserApp);
            axios
                .get(
                    'customers/order-requisition/collections'
                )
                .then(response => {
                    console.log(response.data);
                    let data = response.data;
                    this.collections.terminals = data.terminals;
                    this.collections.stations = data.stations;
                    this.collections.suppliers = data.suppliers;
                    this.collections.products = data.products;
                    // this.collections.filteredProducts = data.products;
                    this.loading.collections = false;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        editItem(item) {
            console.log('Edit item ', item);
            this.orderHistoryItem = item;
            this.openOrderDialog('edit');
        },
        openOrderDialog(type) {
            console.log('Open order dialog');
            this.dialogType = type;
            this.orderRequisitionDialogStatus = true;
        },
        getOrderHistory() {
            console.log('Get order history');
            this.orderHistoryItems = [];
            this.loading.orderHistory = true;
            // this.orderHistoryItem = {};
            // let customer = this.currentUserApp.id;
            axios
                .get(
                    'customers/order-requisition/history'
                )
                .then(response => {
                    console.log('History: ', response.data);
                    this.orderHistoryItems = response.data;
                    this.loading.orderHistory = false;
                })
                .catch(error => {
                    console.error(error);
                });
        },
        downloadOrderHistoryReport() {
            console.log('Download order history report');
        },
        async getCurrentUser() {
            await axios
                .get('user/current')
                .then(response => {
                    this.currentUserApp = response.data;
                    console.log('Current user app: ', this.currentUserApp);
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        formatDatetime(datetime) {
            let parts = datetime.split(' ');
            return parts[0];
        },
        formatNumber(value, decimalPlaces = 2) {
            const number = parseFloat(value);

            return number.toLocaleString('en-US', {
                minimumFractionDigits: decimalPlaces,
                maximumFractionDigits: decimalPlaces,
            });
        },
    },
    watch: {
        $route: {
            immediate: true,
            handler() {
                document.title = 'Order Requisition';
            }
        }
    }
};
</script>

<style>
    .custom-header {
        background-color: #6B6DFD!important;
        color: #fff!important;
    }
</style>